import { DateTime } from "luxon"
import { useContext, useEffect } from "react"
import { useState } from "react"
import { api } from "../../api/api"
import { ModalMotoboy } from "../../components/Modals/Motoboy"
import { NavBar } from "../../components/NavBar"
import { Toast } from "../../utils/Toast"
import { MotoboyContext } from "../../context/MotoboyContext"
import { useDispatch } from "react-redux"
import { SET_MOTOBOYS } from "../../stores/reducers/MotoboyReducers"
import { FiBox, FiPlus, FiSearch, FiTrash2, FiTruck } from "react-icons/fi"
import { OrdersWithMotoboyModal } from "./components/OrdersWithMotoboy"
import ReactInputMask from "react-input-mask"
import { GlobalContext } from "../../context/GlobalContext"
import '../admin.css'

export function MotoboyPage() {
  const { isAccess } = useContext(GlobalContext)
  const dispatch = useDispatch()
  const { findAllMotoboys, motoboys } = useContext(MotoboyContext)
  const [search, setSearch] = useState('')
  const [timer, setTimer] = useState(null)
  const [selectMotoboyId, setSelectMotoboyId] = useState('')

  async function updated(id, key, valueInput) {
    if (!isAccess('entregadores', 'update')) {
      Toast.warning('Você não tem permissão para editar entregadores.')
      return
    }

    dispatch(SET_MOTOBOYS(motoboys.map((e) => e.id === id ? { ...e, [key]: valueInput } : { ...e })))

    clearTimeout(timer)

    const newTimer = setTimeout(async () => {
      if (!id || !key) {
        Toast.success()
      }
      await api.put('/motoboys/' + id, {
        [key]: valueInput
      }).then(() => {
        Toast.success("Atualizado com sucesso")
      }).catch((res) => {
        Toast.warning()
      })
    }, 800)

    setTimer(newTimer)
  }

  async function deleteMotoboy(id) {
    if (!isAccess('entregadores', 'delete')) {
      Toast.warning('Você não tem permissão para deletar entregadores.')
      return
    }

    const confirmation = await Toast.confirm()
    if (confirmation) {
      await api.delete(`/motoboys/${id}`)
      await findAllMotoboys()
    }
  }

  useEffect(() => {
    if (selectMotoboyId) {
      new window.bootstrap.Modal(document.getElementById('modal-orders-motoboy')).show()
    }
  }, [selectMotoboyId])

  return (
    <>
      <NavBar>
        <ModalMotoboy />
        {selectMotoboyId && <OrdersWithMotoboyModal id={selectMotoboyId} set={setSelectMotoboyId} />}
        <main className="admin-page motoboy-page">
          <header className="admin-page-header">
            <div><h1>Entregadores</h1><p>Gerencie a equipe e acompanhe os pedidos de cada entregador</p></div>
            {isAccess('entregadores', 'create') && (
              <button className="admin-primary-button" data-bs-toggle="modal" data-bs-target="#modalMotoboy"><FiPlus /> Novo entregador</button>
            )}
          </header>

          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>Equipe de entrega</h2><p>{motoboys.length} entregadores cadastrados</p></div><FiTruck size={19} /></div>
            <div className="admin-filter-bar">
              <label><span>Pesquisar por nome</span><input type="search" value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && findAllMotoboys(search)} placeholder="Nome do entregador" /></label>
              <button className="admin-secondary-button" onClick={() => findAllMotoboys(search)}><FiSearch /> Pesquisar</button>
            </div>

          <div className="admin-table-wrap"><table className="admin-table">
            <thead>
              <tr>
                <th >Nome</th>
                <th >Telefone</th>
                <th >Ativo</th>
                <th >Criado</th>
                <th >Atualizado</th>
                <th >Pedidos</th>
                <th >Excluir</th>
              </tr>
            </thead>
            <tbody>
              {motoboys.map((motoboy) => {
                return (
                  <tr key={motoboy.id}>
                    <td data-label="Nome">
                      <input type="text" aria-label="Nome"
                        value={motoboy.name}
                        onChange={(e) => updated(motoboy.id, 'name', e.target.value)}
                      />
                    </td>
                    <td data-label="Telefone">
                      <ReactInputMask
                        mask="(99) 9 9999-9999"
                        placeholder="Digite seu telefone"
                        value={motoboy.phone}
                        onChange={(e) => updated(motoboy.id, 'phone', e.target.value)}
                      />
                    </td>
                    <td data-label="Ativo">
                      <label className="admin-toggle">
                        <input
                          type="checkbox"
                          checked={motoboy.active}
                          onChange={(e) => updated(motoboy.id, 'active', e.target.checked)}
                          role="switch"
                        />
                        <span />
                      </label>
                    </td>
                    <td data-label="Criado">{DateTime.fromISO(motoboy.createdAt).toFormat("dd/MM/yyyy HH:mm")}</td>
                    <td data-label="Atualizado">{DateTime.fromISO(motoboy.updatedAt).toFormat("dd/MM/yyyy HH:mm")}</td>
                    <td data-label="Pedidos">
                      <button className="admin-icon-button" onClick={() => setSelectMotoboyId(motoboy.id)} aria-label="Ver pedidos"><FiBox /></button>
                    </td>
                    <td data-label="Excluir"><button className="admin-icon-button danger" onClick={() => deleteMotoboy(motoboy.id)} aria-label="Excluir entregador"><FiTrash2 /></button></td>
                  </tr>
                )
              })}
            </tbody>
          </table>{motoboys.length === 0 && <div className="admin-empty"><FiTruck size={25} /><strong>Nenhum entregador encontrado</strong></div>}</div>
          </section>
        </main>
      </NavBar>
    </>
  )
}


